import * as React from "react";
import { Alert, FormGroup, Input, Label, Button } from "reactstrap";
import * as EmailStore from "../email/EmailStore";
import * as SMSStore from "../sms/SMSStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OrganizationCommunication = ({ organization }) => {
    

    const [emailTo, setEmailTo] = React.useState("");
    const [emailSubject, setEmailSubject] = React.useState("");
    const [emailText, setEmailText] = React.useState("");

    const [emailError, setEmailError] = React.useState(undefined);
    const [emailSent, setEmailSent] = React.useState(undefined);

    const [smsTo, setSmsTo] = React.useState("");
    const [smsText, setSmsText] = React.useState("");

    const [smsError, setSmsError] = React.useState(undefined);
    const [smsSent, setSmsSent] = React.useState(undefined);

    const sendEmail = () => {
        EmailStore.SendEmail(emailTo, emailSubject, emailText)
            .then((response) => {
                if (response.status == 200) {
                    setEmailSent("sent");
                } else {
                    setEmailSent("error");
                    setSmsError(response.data);
                }
            })
            .catch((error) => {
                setEmailSent("error");
                setSmsError(error);
            });
    };

    const sendSMS = () => {
        SMSStore.SendSMS(smsTo, smsText)
            .then((response) => {
                if (response.status == 200) {
                    setSmsSent("sent");
                } else {
                    setSmsSent("error");
                    setSmsError(response.data);
                }
            })
            .catch((error) => {
                setSmsSent("error");
                setSmsError(error);
            });
    };

    return (
        <div className="row">
            <div className="col">
                <FormGroup>
                    <Label for="to">To</Label>
                    <Input id="to" type="text" value={emailTo} onChange={(e) => setEmailTo(e.target.value)}></Input>
                </FormGroup>
                <FormGroup>
                    <Label for="from">From</Label>
                    <Input id="from" type="text" value="noreply@scadco.co.za" readOnly></Input>
                </FormGroup>
                <FormGroup>
                    <Label for="subject">Subject</Label>
                    <Input id="subject" type="text" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)}></Input>
                </FormGroup>
                <FormGroup>
                    <Label for="text">Text</Label>
                    <Input id="text" type="textarea" value={emailText} onChange={(e) => setEmailText(e.target.value)}></Input>
                </FormGroup>

                <Button color="primary" onClick={sendEmail}>
                    Send <FontAwesomeIcon icon={["fad", "paper-plane"]}></FontAwesomeIcon>
                </Button>
                {emailSent == "error" && <Alert color="warning">Email sending failed. {JSON.stringify(emailError)}</Alert>}
                {emailSent == "sent" && <Alert color="success">Email sent successfully</Alert>}
            </div>
            <div className="col">
                <FormGroup>
                    <Label for="to">To</Label>
                    <Input id="to" type="text" value={smsTo} onChange={(e) => setSmsTo(e.target.value)}></Input>
                </FormGroup>
                <FormGroup>
                    <Label for="text">Text</Label>
                    <Input id="text" type="textarea" value={smsText} onChange={(e) => setSmsText(e.target.value)}></Input>
                </FormGroup>

                <Button color="primary" onClick={sendSMS}>
                    Send <FontAwesomeIcon icon={["fad", "mobile"]}></FontAwesomeIcon>
                </Button>
                {smsSent == "error" && <Alert color="warning">SMS sending failed. {JSON.stringify(smsError)}</Alert>}
                {smsSent == "sent" && <Alert color="success">SMS sent successfully</Alert>}
            </div>
        </div>
    );
};

export default OrganizationCommunication;
